var map = {
	"./ads-banner.png": 5502,
	"./affiliate.png": 8374,
	"./bahan1.png": 3798,
	"./bahan2.png": 7565,
	"./bahan3.png": 6436,
	"./bahan4.png": 8427,
	"./bahan5.png": 4770,
	"./bahan6.png": 8777,
	"./bahan7.png": 3024,
	"./bahan8.png": 6855,
	"./banner-about-us.png": 2888,
	"./banner-ingredients.png": 8802,
	"./banner-term-condition.png": 6902,
	"./bayi1.png": 2653,
	"./bayi11.png": 5520,
	"./bayi2.png": 1414,
	"./bayi22.png": 9782,
	"./bayi3.png": 431,
	"./bayi33.png": 3252,
	"./bayi4.png": 7584,
	"./bayi44.png": 7158,
	"./bayi5.png": 4489,
	"./bayi55.png": 4368,
	"./bayi6.png": 6306,
	"./bayi66.png": 7470,
	"./bca.png": 6421,
	"./best-quality1.png": 7184,
	"./best-quality2.png": 9163,
	"./best-quality3.png": 4338,
	"./bg-produk.png": 3758,
	"./bg-terlaris.png": 7695,
	"./bni.png": 6194,
	"./bpom.png": 497,
	"./brand.png": 12,
	"./brand2.png": 8884,
	"./bri.png": 7430,
	"./display1.png": 596,
	"./display2.png": 5247,
	"./display3.png": 8918,
	"./dummy-product-1.png": 5727,
	"./dummy-product-2.png": 1076,
	"./dummy-product-3.png": 1021,
	"./dummy-voucher.png": 9122,
	"./ellipse-pink.png": 8624,
	"./gallery1.png": 1188,
	"./gallery2.png": 4751,
	"./gallery3.png": 6662,
	"./gallery4.png": 921,
	"./gallery5.png": 6096,
	"./gallery6.png": 1131,
	"./gallery7.png": 5778,
	"./halal.png": 7027,
	"./health.png": 2849,
	"./jne.png": 4406,
	"./jnt.png": 3471,
	"./logo.png": 2806,
	"./mandiri.png": 4553,
	"./our-history1.png": 6361,
	"./our-history2.png": 2354,
	"./our-history3.png": 6011,
	"./our-history4.png": 4020,
	"./our-team1.png": 8322,
	"./our-team2.png": 3465,
	"./our-team3.png": 2288,
	"./our-team4.png": 7295,
	"./pattern-affiliate.png": 8647,
	"./pattern-affiliate1.png": 3998,
	"./pattern-affiliate2.png": 1349,
	"./pattern-ellipse.png": 7672,
	"./pattern-health.png": 5089,
	"./pattern-history1.png": 7973,
	"./pattern-history2.png": 622,
	"./pattern-team.png": 4119,
	"./petren.png": 753,
	"./product-1.png": 5340,
	"./product-2.png": 2919,
	"./produk1.png": 7507,
	"./profile.png": 5572,
	"./sicepat.png": 4008,
	"./testimoni1.png": 1448,
	"./testimoni2.png": 7203,
	"./testimoni3.png": 1994,
	"./tiki.png": 8710,
	"./top.png": 6322,
	"./voucher-banner.png": 9634
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4504;